function checkAndRemoveSoldProductFromCart(item, checkoutBool) {
  if (item.properties && item.product_type && (item.product_type === "cpb_ordered" || item.product_type === "cpb_product")) {
    const skuOptions = Object.values(item.properties).filter((sku) => {
      return sku.toString().includes('[') && sku.toString().includes(']')
    })

    
    //const regexp = /[^[\]]+(?=])/g;
    //const skuArrayToCheck = skuOptions.length && skuOptions.map((skuInfo) => {
    //  return skuInfo.match(regexp);
    //})
    

    const skuArrayToCheck = [];
    for (opt of skuOptions) {
      //skuArrayToCheck.push(opt.match(regexp))
      opt.replace(/\[(.+?)\]/g, function($0, $1) {skuArrayToCheck.push($1)})
    }

    if (skuArrayToCheck !== 0) {
      skuArrayToCheck.forEach(async (skuToCheck, i, arr) => {
        const getProductBySku = await fetch(`/admin/variants/search.json?query=sku:${skuToCheck}`);   
        const getProductBySkuJson = await getProductBySku.json();
        const getProductBySkuArray = getProductBySkuJson.variants;
        const productBySku = await getProductBySkuArray.find(product => {
          return product.sku.toLowerCase() === skuToCheck.toLowerCase();
        })
        if (productBySku && productBySku.inventory_policy === "deny" && productBySku.inventory_quantity < 1) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({ quantity: 0, id: String(item.id) })
          })
          if(!checkoutBool && i == arr.length-1) {
            setTimeout(() => {
                      window.location.reload();                     
          }, 1500)

          } else if (checkoutBool) {
            window.location.reload();
          } 
        };
      });
    } 
  };
}

const changeCartBrs = () => {
    let cartItems = document.querySelectorAll('.cart-item');
    for (let cartItem of cartItems) {
      let productOption = cartItem.querySelector('td dl .product-option dd');
      let text1 = productOption.textContent;
      productOption.innerHTML = text1;
    }
}

async function cartOperations(checkoutBool) {
  const getCartInfo = await fetch('/cart.js');
  const cartAllInfo = await getCartInfo.json();
  const shopGet = await fetch('/shop.json')
  const text = await shopGet.text()
  var parser = new DOMParser();
  let doc = parser.parseFromString(text, 'text/html');
  let docArticle = doc.querySelector('#shopify-features').innerHTML;
  const shopInfo = JSON.parse(docArticle)
  const shopId = JSON.parse(shopInfo.shopId)
  const fetchSettingsCPB = await fetch(`https://api.thecustomproductbuilder.com/settings/${shopId}?shopId=${shopId}`);
  const fetchSettingsCPBJson = await fetchSettingsCPB.json();
  const inventoryEnabled = fetchSettingsCPBJson.inventoryEnabled;
  const allItems = cartAllInfo.items;
  window.allItems = allItems;
  if (inventoryEnabled) {
    for (let item of allItems) {
      checkAndRemoveSoldProductFromCart(item, checkoutBool);
    }
  } else {return}
}

function preventDef(e) {
  e.preventDefault();
}

if (window.location.pathname === '/cart') {
  console.log('CPB ajax script is running!');
  document.addEventListener('DOMContentLoaded', () => {
    cartOperations();
    const intervalId = setInterval(() => {
      if (document.querySelector('#checkout[name="checkout"][type="submit"]')) {
        const checkoutButton = document.querySelector('#checkout[name="checkout"][type="submit"]');
        checkoutButton && checkoutButton.addEventListener('click', (e) => {
          //$(this).bind('click', preventDef);
          $(this).bind('click', preventDef)
          cartOperations(true);
          $(this).unbind('click', preventDef);
        })
        changeCartBrs();
        clearInterval(intervalId);
      }
    setTimeout(() => {clearInterval(intervalId)}, 5000)
    })
  });
} 